import { createLifecycleFor } from 'ext/lib/collections';

export const TYPE = 'tags';

export const { resolve, reject } = createLifecycleFor(TYPE);
